import {
    type SxProps,
    type Theme,
    alpha
} from '@mui/material/styles';

const styles = {
    close: (theme) => ({
        backgroundColor: theme.colors.black,
        borderRadius: '50%',
        height: 35,
        minWidth: 35,
        opacity: 0.6,
        padding: '0 !important',
        position: 'absolute',
        right: 20,
        top: 20,
        width: 35
    }),

    input: (theme) => ({
        '& .MuiFormLabel-root': {
            '&.Mui-focused': {
                color: theme.colors.secondaryDark
            },
            zIndex: 1
        },
        '& .MuiInputBase-input': {
            boxSizing: 'border-box',
            fontSize: 16,
            height: 42,
            pl: '12px',
            pt: '12px'
        },
        '& .MuiInputLabel-root': {
            '&.MuiInputLabel-shrink': {
                transform: 'translate(14px, 0px) scale(0.65)'
            },
            top: 10
        },
        flex: 1
    }),

    submit: (theme) => ({
        backgroundColor: theme.colors.plantation,
        color: theme.colors.white,
        flex: 1,
        ml: {
            md: 2,
            xs: 0
        },
        mt: {
            md: 0,
            xs: 4
        }
    }),

    wrapper: (theme) => ({
        backgroundColor: theme.colors.white,
        boxShadow: `0px 0px 15px ${alpha(theme.colors.black, 0.22)}`,
        boxSizing: 'border-box',
        p: 4,
        position: 'relative',
        width: '100%'
    })
} satisfies Record<string, SxProps<Theme>>;

export default styles;
